import TypeIcon from './TypeIcon';

export default TypeIcon;
